import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { googleSession } from '@/lib/api';
import { useAuth } from '@/lib/AuthContext';

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { loginUser, checkAuth } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const params = new URLSearchParams(hash.replace('#', ''));
    const sessionId = params.get('session_id');

    if (!sessionId) {
      navigate('/login', { replace: true });
      return;
    }

    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    (async () => {
      try {
        const res = await googleSession(sessionId);
        loginUser(res.data);
        navigate('/', { replace: true, state: { user: res.data } });
      } catch (err) {
        console.error('Google auth failed:', err);
        navigate('/login', { replace: true });
      }
    })();
  }, [navigate, loginUser, checkAuth]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-muted-foreground font-sans">Authenticating...</p>
      </div>
    </div>
  );
}
